'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002419 from "./presto.-Login-Page-View$$anon$19.js";
import * as $j_presto$002etypes$0024$002dAccount$002dId$0024 from "./presto.types$-Account-Id$.js";
import * as $j_presto$002etypes$0024$002dEmail$0024 from "./presto.types$-Email$.js";
import * as $j_presto$002etypes$0024$002dMorbid$002dUser$002dDetails$0024 from "./presto.types$-Morbid-User-Details$.js";
var $p;
/** @constructor */
function $c_Lpresto_LoginPageView$$anon$18() {
  this.b5a = null;
  this.b52 = null;
  this.b53 = false;
  this.b5b = null;
  this.b5c = false;
  this.b5f = null;
  this.b58 = null;
  this.b59 = false;
  this.b54 = null;
  this.b55 = false;
  this.b56 = null;
  this.b57 = false;
  this.b5d = false;
  this.b5e = false;
  this.b5a = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.b5f = "MorbidUserDetails";
}
export { $c_Lpresto_LoginPageView$$anon$18 as $c_Lpresto_LoginPageView$$anon$18 };
$p = $c_Lpresto_LoginPageView$$anon$18.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LoginPageView$$anon$18;
/** @constructor */
function $h_Lpresto_LoginPageView$$anon$18() {
}
export { $h_Lpresto_LoginPageView$$anon$18 as $h_Lpresto_LoginPageView$$anon$18 };
$h_Lpresto_LoginPageView$$anon$18.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.b5a;
});
$p.M = (function() {
  if ((!this.b53)) {
    this.b52 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.b53 = true;
  }
  return this.b52;
});
$p.O = (function() {
  if ((!this.b5c)) {
    this.b5b = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.b5c = true;
  }
  return this.b5b;
});
$p.E = (function() {
  return this.b5f;
});
$p.t = (function() {
  if ((!this.b59)) {
    this.b58 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("email", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("account", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.b59 = true;
  }
  return this.b58;
});
$p.N = (function() {
  if ((!this.b55)) {
    this.b54 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dEmail$0024.$m_Lpresto_types$Email$().cJ(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dAccount$002dId$0024.$m_Lpresto_types$AccountId$().bl(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.b55 = true;
  }
  return this.b54;
});
$p.Q = (function() {
  if ((!this.b57)) {
    this.b56 = new $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002419.$c_Lpresto_LoginPageView$$anon$19();
    this.b57 = true;
  }
  return this.b56;
});
$p.v = (function() {
  if ((!this.b5e)) {
    this.b5d = false;
    this.b5e = true;
  }
  return this.b5d;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee126) => ((p) => \u03b4scrutinee126.Gp(p)))($j_presto$002etypes$0024$002dMorbid$002dUser$002dDetails$0024.$m_Lpresto_types$MorbidUserDetails$())));
});
var $d_Lpresto_LoginPageView$$anon$18 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LoginPageView$$anon$18, "presto.LoginPageView$$anon$18", ({
  Mj: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_LoginPageView$$anon$18 as $d_Lpresto_LoginPageView$$anon$18 };
//# sourceMappingURL=presto.-Login-Page-View$$anon$18.js.map
